<template>
  <div>
    <div
      v-for="(p, idx) in parts"
      :key="p.id || idx"
      class="border rounded p-1 mb-1"
    >
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="d-flex align-items-center flex-wrap">
          <h6 class="mb-0">{{ govPartTitle(event, p, idx) }}</h6>
          <span class="text-muted small ml-50">{{ govFormatPartRange(p, event.is_all_day) }}</span>
        </div>
        <b-badge v-if="p.location_label" variant="light-primary">{{ p.location_label }}</b-badge>
      </div>
      <b-row v-if="!compact || p.meeting_url" class="mt-50">
        <b-col :md="compact ? 12 : 8" class="mb-25">
          <label class="text-muted small mb-0">Meeting URL</label>
          <div>
            <a v-if="p.meeting_url" :href="govHref(p.meeting_url)" target="_blank" rel="noopener">{{ p.meeting_url }}</a>
            <span v-else>-</span>
          </div>
        </b-col>
        <b-col :md="compact ? 12 : 4" class="mb-25" v-if="!compact || p.meeting_passcode">
          <label class="text-muted small mb-0">Passcode</label>
          <div>{{ p.meeting_passcode || "-" }}</div>
        </b-col>
      </b-row>
    </div>
    <p v-if="!parts.length" class="text-muted mb-0">No dates set.</p>
  </div>
</template>

<script>
import governanceMixin from "./governanceMixin";

/** Read-only list of a governance event's parts, styled like training event parts. */
export default {
  name: "GovernanceEventParts",
  mixins: [governanceMixin],
  props: {
    event: { type: Object, required: true },
    compact: { type: Boolean, default: false },
  },
  computed: {
    parts() {
      return this.govParts(this.event);
    },
  },
};
</script>
